<div [class.rtl]="currLang == 'ar'" class="modal" id="declineEarlyDismissal" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-wrapper">
                    <span class="modal-title">
                        {{'user-management.early-dismissal-requests.decline-reason.title'| translate}}
                    </span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="sub-title">
                    {{'user-management.early-dismissal-requests.decline-reason.sub-title'| translate}}
                </div>
            </div>
            <div class="modal-body">
                <div class="reason-title">
                    {{'user-management.early-dismissal-requests.decline-reason.reason'| translate}}
                </div>
                <textarea name="" id="" cols="120" rows="10"
                placeholder="{{'user-management.early-dismissal-requests.decline-reason.reason-placeholder'| translate}}"
                [(ngModel)]="declineReason"  (input)="onInputChange()"></textarea>
                <div class="decline-reason-length" *ngIf="isButtonDisabled">
                    {{'user-management.early-dismissal-requests.decline-reason.reason-alert'| translate}}
                </div>
            </div>
            <div class="modal-footer">
                <div class="actions-wrapper">
                    <button class="btn btn-primary mb-2" (click)="cancelEarlyDismissal()" [disabled]="isButtonDisabled">
                        {{'user-management.early-dismissal-requests.decline-reason.confirm'| translate}}
                    </button>
                    <button class="btn btn-secondary" data-dismiss="modal" aria-label="Close">
                        {{'user-management.early-dismissal-requests.decline-reason.cancel'| translate}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-error-msg></app-error-msg>